export enum ModalWidth {
  normal,
  medium,
  full,
}
